// Libs
import classNames from 'classnames/bind';
import { Box, Dialog, DialogContent, DialogTitle, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
// Components, Layouts, Pages
// Others
import { DEFAULT_NUMBER_ZERO, DEFAULT_TOOLTIP_DELAY, EMPTY_STRING } from '~/utils/constants/common';
import { DateFormatEnum } from '~/utils/enum/common';
import { IGoogleGmail } from '~/utils/interface/email';
import { extractNameAndEmail, formatDate } from '~/utils/helper/common';
// Styles, images, icons
import styles from './DetailGoogleGmailModal.module.scss';
import { icons } from '~/assets';

type Props = {
  isOpen: boolean;
  data: IGoogleGmail;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const DetailGoogleGmailModal = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, data, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/googleEmail']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Dialog id='detailGoogleGmailModal' open={isOpen} fullWidth maxWidth={'md'} onClose={onClose}>
      <DialogTitle>{t('detail_title_google_email')}</DialogTitle>

      <DialogContent dividers={true}>
        <Typography className={cx('subject')}>{data?.subject || EMPTY_STRING}</Typography>
        <Box component={'div'} className={cx('header')}>
          <Box component={'div'} className={cx('from')}>
            <Typography className={cx('name')}>
              {data?.from ? extractNameAndEmail(data?.from).name : EMPTY_STRING}
            </Typography>
            <Typography className={cx('value')}>
              {data?.from ? extractNameAndEmail(data?.from).email : EMPTY_STRING}
            </Typography>
          </Box>
          <Typography className={cx('value')}>
            {data?.createdAt ? formatDate(data?.createdAt, DateFormatEnum.MM_DD_YYYY_HH_AM_PM) : EMPTY_STRING}
          </Typography>
        </Box>

        <Box component={'div'} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.content || EMPTY_STRING) }} />

        {data.attachments && data.attachments?.length > DEFAULT_NUMBER_ZERO && (
          <Box component={'div'} className={cx('attachments')}>
            <Typography className={cx('name')}>{`${data.attachments.length} attachments`}</Typography>

            <Box component={'div'} className={cx('listAttachments')}>
              {data.attachments.map((item, index) => (
                <Box key={index}>
                  {item.mimeType.includes('image') ? (
                    <Box className={cx('itemImage')}>
                      <img
                        src={`data:${item.mimeType};base64,${item.base64}`}
                        className={cx('image')}
                        alt={t('common_img_text_alt')}
                      />

                      <Box data-tooltip-id={`attachmentImage-${item.attachmentId}`} data-tooltip-place='top'>
                        <Tooltip
                          id={`attachmentImage-${item.attachmentId}`}
                          title={item.filename}
                          placement='top-start'
                          enterDelay={DEFAULT_TOOLTIP_DELAY}
                          leaveDelay={DEFAULT_TOOLTIP_DELAY}
                        >
                          <Typography component={'div'} className={cx('nameFile')}>
                            {item.filename}
                          </Typography>
                        </Tooltip>
                      </Box>
                    </Box>
                  ) : (
                    <Box className={cx('itemFile')}>
                      <Box className={cx('viewFile')}>
                        <img
                          src={icons.commonIconDocument}
                          alt={t('common_img_text_alt')}
                          className={cx('iconFile')}
                        />
                      </Box>

                      <Box data-tooltip-id={`attachmentFile-${item.attachmentId}`} data-tooltip-place='top'>
                        <Tooltip
                          id={`attachmentImage-${item.attachmentId}`}
                          title={item.filename}
                          placement='top-start'
                          enterDelay={DEFAULT_TOOLTIP_DELAY}
                          leaveDelay={DEFAULT_TOOLTIP_DELAY}
                        >
                          <Typography className={cx('nameFile')}>{item.filename}</Typography>
                        </Tooltip>
                      </Box>
                    </Box>
                  )}
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DetailGoogleGmailModal;
